import type { Feature, Polygon } from 'geojson';

// India's official boundary in Jammu & Kashmir and Ladakh (incl. Gilgit-Baltistan,
// Shaksgam and Aksai Chin), simplified to the 1:110m map scale.
// Reference: Survey of India political map. Ring is clockwise (d3-geo exterior convention).
// Arunachal Pradesh is already part of India in the base geometry.
export const indiaClaimFeature: Feature<Polygon> = {
  type: 'Feature',
  properties: { name: 'India' },
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [74.7, 32.48],
        [74.1, 32.78],
        [73.75, 33.1],
        [73.55, 33.25],
        [73.45, 33.6],
        [73.35, 34.0],
        [73.3, 34.3],
        [73.6, 34.6],
        [73.8, 34.9],
        [73.5, 35.3],
        [73.0, 35.4],
        [72.6, 35.8],
        [72.5, 36.1],
        [73.0, 36.6],
        [73.6, 36.9],
        [74.6, 37.05],
        [75.6, 37.0],
        [76.4, 36.8],
        [77.3, 36.3],
        [78.0, 36.05],
        [78.9, 36.0],
        [79.6, 35.7],
        [80.25, 35.45],
        [80.3, 35.0],
        [79.9, 34.6],
        [79.5, 34.3],
        [79.4, 33.9],
        [79.2, 33.4],
        [79.5, 32.7],
        [78.8, 32.4],
        [78.4, 32.5],
        [77.8, 32.6],
        [76.5, 32.7],
        [75.5, 32.3],
        [74.7, 32.48],
      ],
    ],
  },
};
